import { getCodeData, getQueryParams } from '../../../helpers/Common';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import indicatorsService from '../../../../core/services/Technical/IndicatorsService';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import ConstCommon from './../../../common/Const';
import currentState from './../../../helpers/CurrentState';

export const REDUCER_NAME = 'TA_SIGNALS:';
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const FETCH_INDICATORS_SUCCESS = `${REDUCER_NAME}FETCH_INDICATORS_SUCCESS`;
const CHANGE_INDICATOR_SEARCH = `${REDUCER_NAME}CHANGE_INDICATOR_SEARCH`;
const UPDATE_INDICATOR_PRICE = `${REDUCER_NAME}UPDATE_INDICATOR_PRICE`;
const UPDATE_INDICATOR_DATA = `${REDUCER_NAME}UPDATE_INDICATOR_DATA`;

const getIndicatorSearch = () => {
  const result = {};
  const indicatorString = getQueryParams('option');
  if (!indicatorString) {
    return {};
  }
  const codes = indicatorString.split(',');
  const codeData = getCodeData(['stock']);
  codes.forEach((code, index) => {
    if (codeData[code]) {
      result[index] = codeData[code];
    }
  });

  return result;
};

export const fetchIndicators = () => (dispatch, getState) => {
  dispatch(setLoading(true));
  const indicatorIds = [];
  const indicatorById = {};

  const indicatorSearch = getIndicatorSearch();

  if (Object.keys(indicatorSearch).length > 0) {
    const listPromise = [];
    Object.keys(indicatorSearch).forEach((item, index) => {
      indicatorIds.push(item);
      listPromise.push(
        dispatch(fetchIndicatorData(index, indicatorSearch[item].organCode)),
      );
    });
    Promise.all(listPromise).then(() => {
      dispatch({
        type: FETCH_INDICATORS_SUCCESS,
        payload: {
          indicatorSearch,
          indicatorIds,
        },
      });
    });
    return;
  }
  const listOrganizationByTicker = getState()[COMMON_REDUCER_NAME]
    .listOrganizationByTicker;
  indicatorsService.getIndicators().then(res => {
    if (!Array.isArray(res.items)) {
      return;
    }

    res.items.forEach((indicator, index) => {
      indicatorSearch[index] = listOrganizationByTicker[indicator.organCode];
      indicatorIds.push(index);
      indicatorById[index] = {
        id: index,
        ...indicator,
      };
    });

    currentState.add(
      ConstCommon.listComponent.TASignals,
      'Indicator.indicatorSearch',
      indicatorSearch,
    );

    dispatch({
      type: FETCH_INDICATORS_SUCCESS,
      payload: {
        indicatorIds,
        indicatorById,
        indicatorSearch,
      },
    });
  });
};

export const fetchIndicatorData = (id, organCode) => dispatch => {
  return new Promise(function(resolve) {
    indicatorsService.getIndicators({ OrganCode: organCode }).then(res => {
      if (!Array.isArray(res.items)) {
        return;
      }
      dispatch({
        type: UPDATE_INDICATOR_DATA,
        payload: {
          [id]: {
            ...res.items[0],
            id,
          },
        },
      });
      resolve(true);
    });
  });
};

export const changeIndicatorSearch = (id, currentSearch) => ({
  type: CHANGE_INDICATOR_SEARCH,
  payload: {
    id,
    currentSearch,
  },
});

export const fetchIndicatorPrice = (id, organCode) => dispatch => {
  const params = {
    Code: organCode,
  };
  indicatorsService.getLastPriceData(params).then(res => {
    if (!res.items || !res.items[0] || !res.items[0].priceInfo) {
      return;
    }

    dispatch(updateIndicatorPrice({ [organCode]: res.items[0].priceInfo }));
  });
};

export const updateIndicatorPrice = data => ({
  type: UPDATE_INDICATOR_PRICE,
  payload: data,
});

const setLoading = isLoading => dispatch => {
  dispatch({
    type: SET_LOADING,
    payload: isLoading,
  });
};

const initialState = {
  indicatorById: {},
  indicatorIds: [],
  indicatorSearch: {},
  indicatorPrice: {},
  isLoading: true,
  component: {},
};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...state,
        ...initialState,
      };
    case UNMOUNT_COMPONENT:
      return {};
    case FETCH_INDICATORS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    case CHANGE_INDICATOR_SEARCH:
      const indicatorSearch = {
        ...state.indicatorSearch,
        [action.payload.id]: action.payload.currentSearch,
      };

      currentState.add(
        ConstCommon.listComponent.TASignals,
        'Indicator.indicatorSearch',
        indicatorSearch,
      );

      return {
        ...state,
        indicatorSearch,
      };
    case UPDATE_INDICATOR_PRICE:
      return {
        ...state,
        indicatorPrice: {
          ...state.indicatorPrice,
          ...action.payload,
        },
      };
    case UPDATE_INDICATOR_DATA:
      return {
        ...state,
        indicatorById: {
          ...state.indicatorById,
          ...action.payload,
        },
      };

    case SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...state,
        component: action.payload,
      };

    default:
      return state;
  }
};

reducerRegistry.register(REDUCER_NAME, reducer);
